import { loadState } from '../../sessionStorage';
import _ from 'lodash';
import Toast from 'common/Toast';
import { constants, DEFAULT_ACTIVITY_TYPE, ACTIVITY_GLOBAL_COMPETITION, ACTIVITY_LOCAL_COMPETITION, ACTIVITY_SPECIFIC_PASSAGE } from 'config';
import Utils from 'common/Utils';
import { getStudentAssignmentReport } from 'common/api';

const persistedState = loadState() || {};

const state = {
	currentTeacherTab: constants.ACTIVITY_TAB_CURRENT,
	assignments: [],
	pastAssignments: [],
	currentStudentTab: constants.ACTIVITY_TAB_CURRENT,
	studentAssignments: [],
	pastStudentAssignments: [],
	activityTypes: [],
	activityType: DEFAULT_ACTIVITY_TYPE,
	quizCount: 5,
	mustPass: false,
	passageId: null,
	competitionStartDate: null,
	competitionEndDate: null,
	dateRangeType: constants.dateRangeType.sevenDays,
	startDay: 1,
	endDay: 7,
	startHour: 8,
	endHour: 18,
	isWrittenResponseOn: false,
	name: 'Recurring Weekly Activity',
	teamName: null,
	globalCompetitionId: null,
	isLoading: false,
	...persistedState.assignment
};

const addTeacherAssignmentDetail = (assignment, classes) => {
	let startDay, endDay = 1, dueDays = 0;
	let startMonth = '', endMonth = '';
	let totalStudents = 0, totalCompleted = 0, totalInProgress = 0, totalInMissed = 0;
	const today = new Date();

	// put date info in assignment
	if (assignment.startTime) {
		const startDate = new Date(assignment.startTime);
		startDay = startDate.getDate();
		startMonth = startDate.toString().split(" ")[1];
	}
	if (assignment.dueTime) {
		const endDate = new Date(assignment.dueTime);
		endDay = endDate.getDate();
		endMonth = endDate.toString().split(" ")[1];
	}

	if (startMonth === endMonth) {
		assignment.dateRange = `${startDay}-${Utils.ordinal_suffix_of(endDay)}`;
		assignment.monthOfTime = endMonth;
		if (today.getDate() < endDay) {
			dueDays = endDay - today.getDate();
		}
	} else {
		const endDate = new Date(assignment.dueTime);
		assignment.dateRange = `${startMonth} ${startDay} - ${endMonth} ${endDay}`;
		if (today.getTime() < assignment.dueTime) {
			dueDays = Math.floor((endDate - today)/(1000*60*60*24));
		}
	}
	assignment.dueDays = dueDays;
	assignment.totalStudents = totalStudents;
	assignment.totalCompleted = totalCompleted;
	assignment.totalInProgress = totalInProgress;
	assignment.totalInMissed = totalInMissed;

	// make classification of classes including students array in assignement
	if (assignment.assignmentDetails.status !== 'NOT_ACTIVE') {
		assignment.studentAssignments = assignment.studentAssignments.filter(item => item.progressStatus !== 'DELETED');
	}
	assignment.studentAssignments.forEach(studentAssignment => {
		const foundClass = classes.find(classItem => classItem.students_list && classItem.students_list.find(studentItem => studentItem.id === studentAssignment.studentId));
		if (foundClass && foundClass.students_list) {
			let aClassIndex = assignment.classes.findIndex(aClassItem => aClassItem.classId === foundClass.classId);
			const foundStudent = foundClass.students_list.find(studentItem => studentItem.id === studentAssignment.studentId);
			const studentInfo = {
				displayName: foundStudent.displayName,
				username: foundStudent.username
			};

			if (assignment.assignmentDetails.type === ACTIVITY_LOCAL_COMPETITION) {
				studentInfo.classId = foundClass.classId;
				studentInfo.className = foundClass.name;
				if (assignment.classes.length > 0) {
					aClassIndex = 0;
				}
			}
			if (foundStudent) {
				if (aClassIndex >= 0) {
					assignment.classes[aClassIndex].studentAssignments.push({
					...studentAssignment,
					...studentInfo
					});
				} else {
					assignment.classes.push({
					classId: foundClass.classId,
					name: foundClass.name,
					studentAssignments: [{
						...studentAssignment,
						...studentInfo
					}]
					});
				}
				totalStudents++;
				if (studentAssignment.completionStatus) {
					totalCompleted++;
				} else if (studentAssignment.progressStatus) {
					if (studentAssignment.progressStatus === 'NOT_STARTED' || studentAssignment.progressStatus === 'FINISHED') {
						totalInMissed++;
					} else {
						totalInProgress++;
					}
				}

				assignment.totalStudents = totalStudents;
				assignment.totalCompleted = totalCompleted;
				assignment.totalInProgress = totalInProgress;
				assignment.totalInMissed = totalInMissed;
			}
		}
	});

	if (assignment.assignmentDetails.type === ACTIVITY_LOCAL_COMPETITION && assignment.classes.length > 0) {
	  assignment.classes[0].studentAssignments.sort((a, b) => a.assignmentRating < b.assignmentRating ? -1 : 1);
	  assignment.classes[0].studentAssignments.map((item, index) => {
		if (!item.assignmentRating) {
			item.assignmentRating = index + 1;
		}
	  });
	}
};

const addTeacherAssignmentGroup = (groupAssignments, assignmentGroup) => {
	const assignmentData = JSON.parse(assignmentGroup.assignmentDetails.assignmentData);
	let itemTitle = assignmentData.name;
	if (!itemTitle) {
		if (assignmentGroup.assignmentDetails.type === ACTIVITY_GLOBAL_COMPETITION) {
			itemTitle = '2022 Knowledge week competition';
		} else if (assignmentGroup.assignmentDetails.type === ACTIVITY_LOCAL_COMPETITION) {
			itemTitle = 'Competition';
		} else if (assignmentGroup.assignmentDetails.type === ACTIVITY_SPECIFIC_PASSAGE) {
			itemTitle = 'Complete Specific Passage';
		} else {
			itemTitle = `${assignmentData.must_pass ? 'Pass' : 'Complete'} ${assignmentData.quiz_count} passage${assignmentData.quiz_count > 1 ? 's' : ''}`;
		}
	}
	if (assignmentGroup.assignmentDetails.type === ACTIVITY_GLOBAL_COMPETITION
		&& !_.isEmpty(assignmentData.team_name)) {
		itemTitle += ' - ' + assignmentData.team_name;
	}
	const groupItem = {
		...assignmentGroup.assignmentDetails,
		title: itemTitle,
		assignments: assignmentGroup.assignmentItems.reverse(),
		upcomingStartDate: assignmentGroup.upcomingStartDate,
		upcomingDueDate: assignmentGroup.upcomingDueDate
	};

	groupAssignments.push(groupItem);
};

const addDateInfoToStudentAssignment = (assignment) => {
	let startDay, endDay = 1, dueDays = 0;
	let startMonth = '', endMonth = '';
	const today = new Date();

	if (assignment.startDate) {
		const startDate = new Date(assignment.startDate);
		startDay = startDate.getDate();
		startMonth = startDate.toString().split(" ")[1];
	}
	if (assignment.endDate) {
		const endDate = new Date(assignment.endDate);
		endDay = endDate.getDate();
		endMonth = endDate.toString().split(" ")[1];
	}

	if (startMonth === endMonth) {
		assignment.dateRange = `${startDay}-${Utils.ordinal_suffix_of(endDay)}`;
		assignment.monthOfTime = endMonth;
		if (today.getDate() < endDay) {
			dueDays = endDay - today.getDate();
		}
	} else {
		const endDate = new Date(assignment.endDate);
		assignment.dateRange = `${startMonth} ${startDay} - ${endMonth} ${endDay}`;
		if (today.getTime() < assignment.endDate) {
			dueDays = Math.floor((endDate - today)/(1000*60*60*24));
		}
	}
	assignment.dueDays = dueDays;
}

const createNewStudentAssignments = (assignments, currAssignments) => {
	const customAssignments = [...assignments];
	let validAssignments = [];

	customAssignments.forEach(assignment => {
		let newAssignment = { ...assignment };
		if (!newAssignment.studentAssignment) {
			newAssignment.studentAssignment = JSON.parse(JSON.stringify(newAssignment));
		}
		if (newAssignment.studentAssignment.progressStatus === 'PENDING') {
			const foundAssignment = currAssignments.find(fAssignment => fAssignment.studentAssignment.id === newAssignment.studentAssignment.id);
			if (foundAssignment && foundAssignment.studentAssignment.progressStatus !== 'PENDING') {
				newAssignment.studentAssignment = foundAssignment.studentAssignment;
			}
		}
		newAssignment.quizResponses = [];
		const isValidAssignment = !validAssignments.find(item => item.studentAssignment.id === assignment.studentAssignment.id)
		if (isValidAssignment) {
			const foundAssignments = currAssignments.filter(item => item.studentAssignment.id === assignment.studentAssignment.id);
			if (foundAssignments.length > 0) {
			  	newAssignment = foundAssignments[0];
			}
			validAssignments.push(newAssignment);
		}
	});

	return validAssignments.reverse();
}

const createStudentReportAssignments = async (studentId, currentTab, teacherAssignments, currAssignments = []) => {
	let validAssignments = [];
	const reportRequests = [];
	const currStudentAssignmentIds = currAssignments.map(item => item.studentAssignment?.id);

	teacherAssignments.forEach(activity => {
	  activity.assignments.forEach(assignment => {
		const studentAssignment = assignment.studentAssignments.find(item => item.studentId === studentId);
		if (studentAssignment) {
		  if (currentTab === constants.ACTIVITY_TAB_CURRENT || (currentTab === constants.ACTIVITY_TAB_PAST && !currStudentAssignmentIds.includes(studentAssignment.id))) {
			validAssignments.push({ id: studentAssignment.id })
		  	reportRequests.push(getStudentAssignmentReport(studentAssignment.id));
		  }
		}
	  })
	});

	if (reportRequests.length > 0) {
		let isFetchingFailed = false;
		const reportResults = await Promise.all(reportRequests);
		reportResults.forEach(result => {
			if (isFetchingFailed) return;

			if (result.success) {
				const resultAssignment = result.data;
				const foundIndex = validAssignments.findIndex(item => item.id === resultAssignment.studentAssignment.id);
				if (foundIndex >= 0) {
					const assignment = resultAssignment;
					addDateInfoToStudentAssignment(assignment);
					validAssignments[foundIndex] = assignment;
				}
			} else {
				validAssignments = [];
				Toast.error(result.message);
				isFetchingFailed = true;
				return;
			}
		});
	}

	return validAssignments;
}

const getters = {}

const mutations = {
	updateActivityTypes(state, activityTypes) {
		state.activityTypes = activityTypes;
	},
	updateAssignments(state, newAssignments) {
		state.assignments = newAssignments;
		state.quizCount = 5;
		state.competitionStartDate = null;
		state.competitionEndDate = null;
		state.mustPass = false;
		state.startDay = 2;
		state.endDay = 1;
		state.startHour = 8;
		state.endHour = 18;
		state.globalCompetitionId = null;
	},
	updatePastAssignments(state, newAssignments) {
		state.pastAssignments = newAssignments;
	},
	updateTeacherTab(state, tab) {
		state.currentTeacherTab = tab;
	},
	updateStudentAssignments(state, newAssignments) {
		state.studentAssignments = newAssignments;
		state.studentAssignments.forEach(assignment => addDateInfoToStudentAssignment(assignment))
	},
	updatePastStudentAssignments(state, newAssignments) {
		state.pastStudentAssignments = newAssignments;
	},
	updateStudentTab(state, tab) {
		state.currentStudentTab = tab;
	},
	updateActivityType(state, activityType) {
		state.activityType = activityType;
		if (activityType === DEFAULT_ACTIVITY_TYPE) {
			state.dateRangeType = constants.dateRangeType.sevenDays;
			state.isWrittenResponseOn = false;
		}
	},
	updateQuizCount(state, count) {
		state.quizCount = count;
	},
	updateMustPass(state, mustPass) {
		state.mustPass = mustPass;
	},
	updatePassageId(state, passageId) {
		state.passageId = passageId;
	},
	updateCompetitionDate(state, dateRange) {
		state.competitionStartDate = dateRange.start;
		state.competitionEndDate = dateRange.end;
	},
	updateStartDay(state, startDay) {
		state.startDay = startDay;
	},
	updateEndDay(state, endDay) {
		state.endDay = endDay;
	},
	updateStartHour(state, startHour) {
		state.startHour = startHour;
	},
	updateEndHour(state, endHour) {
		state.endHour = endHour;
	},
	updateLoading(state, isLoading) {
		state.isLoading = isLoading;
	},
	updateDateRangeType(state, type) {
		state.dateRangeType = type;
	},
	updateWrittenResponseOn(state, isOn) {
		state.isWrittenResponseOn = isOn;
	},
	updateActivityName(state, name) {
		state.name = name;
	},
	updateTeamName(state, teamName) {
		state.teamName = teamName;
	},
	updateGlobalCompetitionId(state, activityId) {
		state.globalCompetitionId = activityId;
	}
}

const actions = {
	makeAssignments(context, { assignments, classes }) {
		let currAssignmentIds = [];
		const currAssignments = context.state.assignments;
		const customAssignments = [...assignments];
		const groupAssignments = [];
		const activityTab = context.state.currentTeacherTab;

		if (activityTab === constants.ACTIVITY_TAB_PAST) {
		  // collect assignment ids of current activites
		  currAssignments.forEach(assignmentGroup => {
			const assignmentIds = assignmentGroup.assignments.map(item => item.id);
			currAssignmentIds = currAssignmentIds.concat(assignmentIds);
		  });
		}

		// filter past activities in rest of current activities if tab is past
		customAssignments.forEach(assignmentGroup => {
		  	assignmentGroup.assignmentItems.map(assignment => {
				assignment.classes = [];
				addTeacherAssignmentDetail(assignment, classes);
		  	});

			if (activityTab === constants.ACTIVITY_TAB_PAST) {
				assignmentGroup.assignmentItems = assignmentGroup.assignmentItems.filter(item => !currAssignmentIds.includes(item.id));
			}

			if (assignmentGroup.assignmentItems.length > 0) {
				addTeacherAssignmentGroup(groupAssignments, assignmentGroup);
			}
		});

	  	if (activityTab === constants.ACTIVITY_TAB_CURRENT) {
			context.commit('updateAssignments', groupAssignments.reverse());
	  	} else {
			context.commit('updatePastAssignments', groupAssignments.reverse());
		}
	},
	makePastAssignments(context, assignments) {
		const classes = context.state.classes;
		let currAssignmentIds = [];
		const currAssignments = context.state.assignments;
		const customAssignments = [...assignments];
		const groupAssignments = [];

		// collect assignment ids of current activites
		currAssignments.forEach(assignmentGroup => {
		  const assignmentIds = assignmentGroup.assignments.map(item => item.id);
		  currAssignmentIds = currAssignmentIds.concat(assignmentIds);
		});

		// filter past activities in rest of current activities
		customAssignments.forEach(assignmentGroup => {
		  	assignmentGroup.assignmentItems.map(assignment => {
				assignment.classes = [];
				addTeacherAssignmentDetail(assignment, classes);
		  	});

			const validAssignments = assignmentGroup.assignmentItems.filter(assignment => assignment.classes.length > 0);
			assignmentGroup.assignmentItems = assignmentGroup.assignmentItems.filter(item => !currAssignmentIds.includes(item.id));
			if (validAssignments.length > 0 && assignmentGroup.assignmentItems.length > 0) {
				addTeacherAssignmentGroup(groupAssignments, assignmentGroup);
			}
		});

		context.commit('updatePastAssignments', groupAssignments.reverse());
	},
	initClassesForActivity(context, { activityItem, classes }) {
		const teacherTab = context.state.currentTeacherTab;
		const activities = teacherTab === constants.ACTIVITY_TAB_CURRENT ? context.state.assignments : context.state.pastAssignments;
		const activity = activityItem ? activityItem : (activities.length > 0 ? activities[0].assignments[0] : null);
		if (!activity) return;
		const newClasses = _.cloneDeep(classes);
		let activityClassIds = [];
		let checkedStudentIds = [];
		if (activity.assignmentDetails.type === ACTIVITY_LOCAL_COMPETITION) {
			activityClassIds = activity.classes.length > 0 ? activity.classes[0].studentAssignments.map(item => item.classId) : [];
		}
		newClasses.map(classItem => {
		  let foundClass = null;
		  if (activity.assignmentDetails.type === ACTIVITY_LOCAL_COMPETITION && activityClassIds.includes(classItem.classId)) {
			foundClass = activity.classes[0];
		  } else {
			foundClass = activity.classes.find(item => item.classId === classItem.classId);
		  }
		  if (foundClass && classItem.students_list) {
			classItem.students_list.map(student => {
				const fIndex = foundClass.studentAssignments.findIndex(item => item.id === student.id && !checkedStudentIds.includes(student.id));
				if (fIndex >= 0)  {
					checkedStudentIds.push(student.id);
					student.checked = true;
				}
			})
		  }
		});
		return newClasses;
	},
	makeStudentAssignments(context, assignments) {
		if (!assignments || !assignments.length || assignments.length === 0) {
			context.commit('updateStudentAssignments', []);
			return;
		}
		context.commit('updateLoading', true);
		const newAssignments = createNewStudentAssignments(assignments, context.state.studentAssignments);
		context.commit('updateStudentAssignments', newAssignments);
		context.commit('updateLoading', false);
	},
	async loadCurrentAssignmentsForStudent(context, studentId) {
		context.commit('updateLoading', true);
		const newAssignments = await createStudentReportAssignments(studentId, context.state.currentStudentTab, context.state.assignments);
		context.commit('updateStudentAssignments', newAssignments);
		context.commit('updateLoading', false);
	},
	makePastStudentAssignments(context, assignments) {
		if (!assignments || !assignments.length || assignments.length === 0) {
			context.commit('updatePastStudentAssignments', []);
			return;
		}
		const newAssignments = createNewStudentAssignments(assignments, context.state.studentAssignments);
		context.commit('updatePastStudentAssignments', newAssignments);
		context.commit('updateLoading', false);
	},
	async loadPastAssignmentsForStudent(context, studentId) {
		context.commit('updateLoading', true);
		const newAssignments = await createStudentReportAssignments(studentId, context.state.currentStudentTab, context.state.pastAssignments, context.state.studentAssignments);
		context.commit('updatePastStudentAssignments', newAssignments);
		context.commit('updateLoading', false);
	},
	updateStudentAssignmentItem(context, studentAssignment) {
		const studentTab = context.state.currentStudentTab;
		const newAssignments = JSON.parse(JSON.stringify(studentTab === constants.ACTIVITY_TAB_CURRENT ? context.state.studentAssignments : context.state.pastStudentAssignments));
		const foundIndex = newAssignments.findIndex(item => item.studentAssignment.id === studentAssignment.id);
		if (foundIndex >= 0) {
			addDateInfoToStudentAssignment(studentAssignment)
			newAssignments[foundIndex].studentAssignment = studentAssignment;
			if (studentTab === constants.ACTIVITY_TAB_CURRENT) {
				window.rt_bridge.session.assignments = newAssignments;
				context.commit('updateStudentAssignments', newAssignments);
			} else {
				context.commit('updatePastStudentAssignments', newAssignments);
			}
		}
	},
	updateStudentAssignment(context, assignmentItem) {
		const studentAssignment = assignmentItem.studentAssignment;
		const studentTab = context.state.currentStudentTab;
		const newAssignments = JSON.parse(JSON.stringify(studentTab === constants.ACTIVITY_TAB_CURRENT ? context.state.studentAssignments : context.state.pastStudentAssignments));
		const foundIndex = newAssignments.findIndex(item => item.studentAssignment.id === studentAssignment?.id);
		if (foundIndex >= 0) {
			addDateInfoToStudentAssignment(studentAssignment)
			assignmentItem.studentAssignment = studentAssignment;
			newAssignments[foundIndex] = assignmentItem;
			if (studentTab === constants.ACTIVITY_TAB_CURRENT) {
				window.rt_bridge.session.assignments = newAssignments;
				context.commit('updateStudentAssignments', newAssignments);
			} else {
				context.commit('updatePastStudentAssignments', newAssignments);
			}
		}
	},
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};